import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
// The list of business functions Giga acts as a co-pilot for. These cycle in
// the founder hero headline ("...your AI co-pilot for ___") to dramatize that
// Giga covers every function, not just one.
const FUNCTIONS = ['finance', 'marketing', 'sales', 'operations', 'hiring', 'support', 'growth'];
export function RotatingFunction() {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => {
      setIndex(i => (i + 1) % FUNCTIONS.length);
    }, 1800);
    return () => clearInterval(id);
  }, [reduce]);
  return <span className="relative inline-flex align-bottom text-[#EA580C]" data-id="element-1831" data-mp="1cqz8m83bif7x">
      <AnimatePresence mode="wait" data-id="element-1832" data-mp="3jg449nu7236l">
        <motion.span key={FUNCTIONS[index]} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: '0.4em',
        filter: 'blur(4px)'
      }} animate={{
        opacity: 1,
        y: 0,
        filter: 'blur(0px)'
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: '-0.4em',
        filter: 'blur(4px)'
      }} transition={{
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="inline-block whitespace-nowrap" data-id="element-1833" data-mp="3jh5drnvkahm7">
          {FUNCTIONS[index]}
        </motion.span>
      </AnimatePresence>
    </span>;
}